import { QuotaPayload } from '../../shared/interfaces/quota.interface';

export class SurveyQuotas<
  T extends Pick<QuotaPayload, 'buyer_quota_id' | 'criteria'>
> {
  constructor(private _quotas: T[]) {}

  public hasQualification(qualificationId: number): boolean {
    return this._quotas.some((quota) =>
      quota.criteria.some(
        (criterion) =>
          Number(criterion.qualification_code) === Number(qualificationId)
      )
    );
  }

  public withAnyOfQualifications(qualificationIds: number[]): T[] {
    return this._quotas.filter((quota) =>
      quota.criteria.some((criterion) =>
        qualificationIds
          .map(Number)
          .some(
            (qualificationId) =>
              Number(criterion.qualification_code) === Number(qualificationId)
          )
      )
    );
  }

  public hasQuota(buyerQuotaId: string): boolean {
    return this._quotas.some((quota) => quota.buyer_quota_id === buyerQuotaId);
  }
}
